function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.1 52h49c1.4 0 2.5-1.1 2.5-2.5S58.5 47 57.1 47H8.2l13.7-15.1c1-1 1-2.5 0-3.5s-2.6-1-3.6 0L.7 47.9c-.5.6-.7 1.3-.7 1.9 0 .7.2 1.4.7 1.9l17.4 19.5c.5.5 1.1.7 1.8.7s1.3-.2 1.8-.7c1-1 1-2.8 0-3.8L8.1 52z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M91.7 0h-55C32.2 0 29 3.6 29 7.9v14.2c0 1.1 1.4 2.1 2.5 2.1s2.5-1 2.5-2.1V8.9C34 6.7 35.5 5 37.8 5h52.9C93.5 5 95 7 95 9.8V90c0 2.1-1.6 5.1-4.2 5.1h-53c-2.2 0-3.8-2-3.8-4.1V78.8c0-1.1-1.3-2-2.5-2s-2.5.9-2.5 2v13c0 4.3 3.2 8.1 7.7 8.1h55c4.5 0 8.3-3.8 8.3-8.1v-84c0-4.2-3.8-7.8-8.3-7.8z"
});

var SvgMenuExit = function SvgMenuExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _ref, _ref2);
};

export default SvgMenuExit;